import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProfileAPI from "apiConfig/ProfileAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  data: null,
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncSendOTP = createAsyncThunk(
  "accountSetting/fetchAsyncSendOTP",
  async ({ otp, userid, mobileNumber }, { rejectWithValue }) => {
    try {
      const response = await ProfileAPI.patch(`/profiles/${userid}`, {
        otp,
        mobileNumber,
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const SendOTPSlice = createSlice({
  name: "sendOTP",
  initialState,
  reducers: {
    resetSendOTP: state => {
      state.data = null;
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncSendOTP.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchAsyncSendOTP.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.status = Status.LOADED;
      })
      .addCase(fetchAsyncSendOTP.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetSendOTP } = SendOTPSlice.actions;
export default SendOTPSlice.reducer;
